import React, { useState } from "react";
import "./matching.css";

function NakshatraMatch() {
  const [params, setParams] = useState({
    boy_nakshatra: "2",
    girl_nakshatra: "12",
    lang: "en",
  });

  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // ✅ Loading state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setParams({ ...params, [name]: value });
  };

  const match = () => {
    setError("");
    setResult(null);
    setLoading(true); // start loading

    fetch(
      `https://api.jyotishamastroapi.com/api/matching/nakshatra-match?boy_nakshatra=${params.boy_nakshatra}&girl_nakshatra=${params.girl_nakshatra}&lang=${params.lang}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",
        },
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`API error: ${res.status}`);
        return res.json();
      })
      .then((data) => setResult(data.response || data))
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false)); // stop loading
  };

  const kootas = [
    "dina",
    "gana",
    "mahendra",
    "sthree",
    "yoni",
    "rasi",
    "rasiathi",
    "vasya",
    "rajju",
    "vedha",
  ];

  const languages = [
    { label: "English", value: "en" },
    { label: "Hindi", value: "hi" },
    { label: "Tamil", value: "ta" },
    { label: "Telugu", value: "te" },
    { label: "Kannada", value: "ka" },
    { label: "Malayalam", value: "ml" },
    { label: "Bengali", value: "be" },
    { label: "Greek", value: "gr" },
    { label: "Marathi", value: "mr" },
  ];

  return (
    <div className="container">
      <div className="ra-main-matchmaking">
        <h2>Nakshatra Matching</h2>

        <div className="ra-main-form-section">
          <div className="form-section">
            <h3>Match Parameters</h3>
            <div
              className="ra-main-matching-form-group"
             
            >
              <div className="matching-form-group">
                <label>Boy Nakshatra</label>
                <select
                  name="boy_nakshatra"
                  value={params.boy_nakshatra}
                  onChange={handleChange}
                >
                  {[...Array(27)].map((_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </div>

              <div className="matching-form-group">
                <label>Girl Nakshatra</label>
                <select
                  name="girl_nakshatra"
                  value={params.girl_nakshatra}
                  onChange={handleChange}
                >
                  {[...Array(27)].map((_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {i + 1}
                    </option>
                  ))}
                </select>
              </div>

              <div className="matching-form-group">
                <label>Language</label>
                <select name="lang" value={params.lang} onChange={handleChange}>
                  {languages.map((lang) => (
                    <option key={lang.value} value={lang.value}>
                      {lang.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        <button
          className="match-btn"
          onClick={match}
          disabled={loading} // ✅ disable button while loading
        >
          {loading ? "Matching..." : "Match"}
        </button>

        {/* Loading Message */}
        {loading && !error && <div className="loading-msg">Loading...</div>}

        {/* Error Message */}
        {error && <div className="error-msg">Error: {error}</div>}

        {result && (
          <div className="result-section">
            <h3>Result</h3>

            <div className="score-box">
              <p>
                <strong>Total Score:</strong> {result.score} / 10
              </p>
              {result.bot_response && (
                <p className="bot-response">💡 {result.bot_response}</p>
              )}
            </div>

            <div className="koota-grid">
              {kootas.map((koota) => {
                const item = result[koota];
                if (!item) return null;

                const boyVal =
                  item.boy_star ||
                  item.boy_gana ||
                  item.boy_rasi ||
                  item.boy_yoni ||
                  item.boy_lord ||
                  item.boy_rajju ||
                  "-";
                const girlVal =
                  item.girl_star ||
                  item.girl_gana ||
                  item.girl_rasi ||
                  item.girl_yoni ||
                  item.girl_lord ||
                  item.girl_rajju ||
                  "-";

                return (
                  <div key={koota} className="koota-card">
                    <h4>
                      {item.name} ({item[koota]} / {item.full_score})
                    </h4>
                    <p>
                      <strong>Boy:</strong> {boyVal}
                    </p>
                    <p>
                      <strong>Girl:</strong> {girlVal}
                    </p>
                    {item.description && (
                      <p className="description">{item.description}</p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default NakshatraMatch;
